import React from 'react';
import { SectionLayout } from '@/components/section-layout';
import { SelectionsList } from './SelectionsList';

export function PMSelectionsPage() {
  return (
    <SectionLayout title="Selections">
      <SelectionsList />
    </SectionLayout>
  );
} 